// SEC-01: cable URL helpers. The JWT travels as a ?token= query-param because browsers
// cannot set WebSocket request headers; backend connection.rb decodes request.params[:token]
// (strips "Bearer ", revocation-aware). SECURITY: callers must never log the tokenized URL.

// http(s)://host → ws(s)://host/cable
export function buildCableUrl(apiUrl) {
  return apiUrl.replace(/^http/, "ws") + "/cable";
}

// Append the JWT as ?token=<raw>. Strips a leading "Bearer " (connection.rb also strips it;
// we send the raw token for a clean URL) and URL-encodes. Returns url unchanged if no token.
export function appendCableToken(cableUrl, token) {
  if (!token) return cableUrl;
  const raw = String(token).replace(/^Bearer\s+/i, "");
  if (!raw) return cableUrl;
  return appendQuery(cableUrl, `token=${encodeURIComponent(raw)}`);
}

function appendQuery(url, query) {
  return `${url}${url.includes("?") ? "&" : "?"}${query}`;
}

// FT-215: the server logs anonymous connections with the client build version and platform
// (`[cable-anon]`), so the remaining builds without a cable token can be measured.
function appendCableClient(cableUrl, version, platform) {
  return appendQuery(cableUrl,
    `client_version=${encodeURIComponent(version || "0.0.0")}&client_platform=${encodeURIComponent(platform)}`);
}

// The consumer calls the returned function on every (re)connect, so base, token, version
// and platform are re-read each time. Token goes last (appendCableToken).
export function createCableUrlFn({ resolveBase, getToken, getVersion, getPlatform }) {
  return () => appendCableToken(appendCableClient(resolveBase(), getVersion(), getPlatform()), getToken());
}

// Development: ALWAYS the API host (the local backend returns prod region + cable_urls, which
// would point the local front at the PROD cable). Production: the regional cable URL when the
// region is mapped, else derived from the API host.
export function resolveCableBase({ isDevelopment, region, cableUrls, apiUrl }) {
  if (!isDevelopment && region && cableUrls && cableUrls[region]) return cableUrls[region];
  return buildCableUrl(apiUrl);
}

// Reads the live store on every call (no snapshot), so a region switch is picked up on reconnect.
export function resolveCableBaseFromStore(store, nodeEnv) {
  return resolveCableBase({
    isDevelopment: nodeEnv === "development",
    region: store.state.region,
    cableUrls: store.state.cable_urls,
    apiUrl: store.getters.getApiUrl,
  });
}
